import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { CustomerAssessmentsAction } from "./customer-assessments.action";
import { CustomerAssessmentsState } from "./customer-assessments.model";

const INITIAL_STATE: CustomerAssessmentsState = {
	currentAssessment: undefined,
	customerAssessments: [],
};

export const customerAssessmentsReducer = createReducer(
	INITIAL_STATE,
	on(CustomerAssessmentsAction.getAssessmentSuccess, (state, { model }) =>
		updateState(state, {
			currentAssessment: model.assessmentForm,
		})
	),
	on(CustomerAssessmentsAction.getAssessmentFail, (state) =>
		updateState(state, {
			currentAssessment: undefined,
		})
	),
	on(CustomerAssessmentsAction.getCustomerAssessmentsSuccess, (state, { assessments }) =>
		updateState(state, {
			customerAssessments: assessments,
		})
	)
);
